
    <div>
      <spinner *ngIf="!entity"></spinner>
      <widget-embed
        *ngIf="entity"
        [entity]="entity"
        [layout]="'full'"
        [options]="sidebar_options"
      ></widget-embed>
    </div>
  